import { createUseStyles } from "react-jss";
import { SurveySvg } from "./SurveySvg";
import { Fragment } from "react/jsx-runtime";

const FIRST_SECTION = 1;

export const Header = ({ currentSection }: { currentSection: number }) => {
  const classes = useStyles();
  return (
    <div>
      <img
        src="/dils-logo.png"
        className={`mt-4 ${classes.dilsLogo}`}
        alt="Dils Logo"
      />

      <div className="mt-5"></div>

      {currentSection === FIRST_SECTION && (
        <Fragment>
          <h2 className={`mb-4 ${classes.surveyTitle}`}>
            <SurveySvg />
            La tua opinione <span className={classes.dilsRed}>conta</span>
          </h2>

          <div className={classes.surveyCard}>
            <div>
              <i className={`las la-comment me-1 ${classes.cardIcon}`} />
              <span>Come valuti il servizio offerto da Dils?</span>{" "}
              <strong> Dacci il tuo feedback.</strong>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

const useStyles = createUseStyles({
  dilsLogo: {
    maxWidth: 150,
  },
  surveyTitle: {
    marginTop: 30,
    marginBottom: 14,
    fontSize: 22,
  },
  surveyCard: {
    backgroundColor: "#404254",
    color: "#FFF",
    borderRadius: 10,
    padding: "10px 15px",
    textAlign: "left",
  },
  cardIcon: {
    fontSize: 20,
  },
  dilsRed: {
    color: "#e73838",
  },
});
